import React, { useEffect, useState } from 'react';
import { BaseConfig } from '../../BaseConfig';
import moment from 'moment';
import {Chart} from 'chart.js'
import { constants } from '../../../misc/constants';
import Tools from '../../../cvp-webgames-core/Misc/Tools';
const etc02ValToDisplay = 35;
var bigData: any = [];
var isMounted = false;
const ETC02GraphUI = (props: ETC02GraphUIConfig) => {
	const chartIdInDom = Tools.generateGuid();
	var timeout: any = null;
	useEffect(() => {
		var heartbeatChartElem: any = document.getElementById(chartIdInDom)
		var heartbeatCtx = heartbeatChartElem.getContext('2d')
		var heartbeatDataset: any = null
			var heartbeatCounter = 0

			const getCorrectInterval = () => {
				// var invertedHr = props.parameters.heartRate;
				// // var invertedHr = max(constants.monitor.heartRateData) - props.parameters.heartRate;
				// var safeHr = invertedHr > 1 ? invertedHr : 1;
				// return 60 * 1000 / (heartbeatDataset.length * safeHr);
				return 60 * 1000 / (100 * 58);
			}
			var interval = getCorrectInterval();
			// var interval = calculateLoopInterval();
			var heartbeatData =  bigData;

			var config = {
				type: 'line',
				options: {
					legend: { display: false },
					//responsive: true,
					tooltips: {
						enabled: false
					},
					title: {
						display: false
					},
					scales: {
						xAxes: [{
							display: false,
							type: 'time',
							distribution: 'linear',
							bounds: 'data',
							time: {
								unit: 'second'
							}
						}],
						yAxes: [{
							display: false
						}]
					}
				}
			}
			var heartbeatChartCfg: any = {
				data: {
					datasets: [{
					borderColor: 'lime',
					fill: false,
					data: heartbeatData,
					pointRadius: 0
					}]
				},
				options: {
					scales: {
					xAxes: [{
						display: false,
						type: 'time',
						distribution: 'linear',
						bounds: 'data',
						time: {
							unit: 'second'
						}
					}],
					yAxes: [{
						display: false,
						ticks: {
							min: -1.3,
							max: 1.3
						}
					}]
					}
				},
				...config
			}
			
			var heartbeatChart = new Chart(heartbeatCtx, heartbeatChartCfg);
			const getHeartbeatValue = () => {
				var speed = 1;
				if(speed < 1) {
					speed = 1;
				}
				heartbeatCounter+=speed;

				if(heartbeatCounter >= heartbeatDataset.length)
					heartbeatCounter = 0;

				var result = heartbeatDataset[heartbeatCounter]

				if(props.isDead) {
					return 0; //flatline
				}
				
				return result
			}
			

		if(isMounted) {
			isMounted = false;

			const loop = () => {  
				interval = getCorrectInterval();
				// var fillStep = 10;
				// var correctDataLength = calculateHrDataLength() / fillStep;
			// interval = calculateLoopInterval();
				heartbeatData.push({
					x:  moment().toDate(),
					y: getHeartbeatValue()
				})
				heartbeatData.shift();

				// if(heartbeatData.length > correctDataLength) {
				// 	while(true) {
				// 		heartbeatData.shift();
				// 		if(heartbeatData.length < correctDataLength) {
				// 			break;
				// 		}
				// 	}
				// }
				
				heartbeatChart.update()
				// if(respirationData.length > correctDataLength) {
				// 	while(true) {
				// 		respirationData.shift();
				// 		if(respirationData.length < correctDataLength) {
				// 			break;
				// 		}
				// 	}
				// }
				
				timeout = setTimeout(loop, interval)
			}

			const fill = () => {
				// fill heartbeat values
				for (var i = constants.monitor.hrDataLength; i > 0; i-=10) {
					heartbeatData.push({
						x: moment().add(-i, 'ms').toDate(),
						y: getHeartbeatValue()
					})
				}
				
				loop()
			}

			

			fill()
		} else {
			const loop2 = () => {  
				interval = getCorrectInterval();
				heartbeatChart.update()
				timeout = setTimeout(loop2, interval)
			}
			loop2()
		}
		return () => {
			isMounted = true;
			if(timeout) {
				clearInterval(timeout);
				timeout = null;
			}
		}
	}, [])
	return (
		<main>
			<div className="graph modal-disable-select">
				<div style={{
					width: '100%',
					height: '100%'
				}}>
					<canvas style={{
					}} id={chartIdInDom} height="30"></canvas>
				</div>
			</div>
		</main>
	);

};

export interface ETC02GraphUIConfig extends BaseConfig{
	data: any;
	isDead: boolean;
	canvasHeight: number;
	isETC02Attached: boolean;
	onDataUpdated: (newData: ETC02GraphUIData) => void;
}

export interface ETC02GraphUIData {
	data: any;
}

export interface ETC02GraphUISingleData {
	x: Date;
	y: number;
}

export default ETC02GraphUI;